module.exports = __webpack_public_path__ + "img/discount-bag.fdb3e303.png";